import {
  Directive,
  ElementRef,
  HostListener,
  Renderer2,
  AfterViewInit,
  OnChanges,
} from "@angular/core";

@Directive({
  selector: "[sidebarDropdownPosition]",
})
export class SidebarDropdownPositionDirective
  implements AfterViewInit, OnChanges
{
  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngAfterViewInit() {
    this.reposition();
  }

  ngOnChanges() {
    this.reposition();
  }

  private reposition() {
    const elm: HTMLElement = this.elementRef.nativeElement;
    const parent: HTMLElement = elm.parentElement as any;
    this.renderer.setStyle(elm, "top", parent.offsetTop + "px");
  }

  @HostListener("window:resize", ["$event"])
  onResize(event) {
    this.reposition();
  }
}
